import gql from 'graphql-tag';

export const getPlotEvidencesQuery = gql`
  query allPlotEvidences(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: PlotEvidenceFilter
  ) {
    items: allPlotEvidences(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      plotId
      evidenceId {
        id
        name
        __typename
      }
      folderNumber
      orderIndex
      requiredActors
      createdAt
      updatedAt
      deletedAt
      __typename
    }
    total: _allPlotEvidencesMeta(
      page: $page
      perPage: $perPage
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
